import React from 'react';
import PolicyPage from './PolicyPage';

// Content from Admin → policies (falls back to the recommended text until saved).
function TermAndServices() {
  return <PolicyPage policyKey="termsAndCondition" icon="fa-file-text-o" />;
}

export default TermAndServices;
